<template>
  <div class="bd-BookingDemo">
    <template v-for="(box, index) in BOXES" :key="box.id">
      <a
        :href="box.link"
        :style="{
          '--color': `var(${box.color})`,
          '--color-rgb': box.rgb
        }"
        class="bd-BookingDemo_Item"
        target="_blank"
        @click="emit('click', box)"
      >
        <AppImage v-if="box.person" :name="box.person" height="64" width="64" />

        <div class="bd-BookingDemo_BoxContent">
          <AppTitle :level="3" class="bd-BookingDemo_BoxTitle" disable-margin>
            {{ box.title }}
          </AppTitle>

          <i18n-t
            :keypath="box.subtitle"
            class="bd-BookingDemo_BoxSubtitle"
            scope="global"
            tag="div"
          />
          <div class="bd-BookingDemo_BoxButton">
            {{ box.linkText }}

            <AppIcon height="24" icon-name="shortcut" width="24" />
          </div>
        </div>
      </a>

      <AppDivider v-if="BOXES.length > 1 && index + 1 < BOXES.length" no-margin />
    </template>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import { memoizeGetCssVariableValue, memoizeHexToRgb } from '@/utils/memoizations'
import { DEMO_CALENDLY_LINK, CONSULTATION_CALENDLY_LINK } from '@/utils/support'

import AppDivider from '@/components/ui/AppDivider'
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import AppImage from '@/components/ui/AppImage'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'BookingDemo'
})

const emit = defineEmits({
  click: null
})

const { t } = useI18n()

const BOXES = [
  {
    id: 0,
    title: 'onboarding.demo.product_demo',
    subtitle: 'onboarding.demo.product_demo.subtitle',
    linkText: 'support.okr_review.link.text',
    color: '--grade-high-color-next',
    link: DEMO_CALENDLY_LINK,
    person: 'onboarding-demo-irina',
    tracking: 'demo'
  },
  {
    id: 1,
    title: 'support.okr_consulting',
    subtitle: 'onboarding.okr_consulting.subtitle',
    linkText: 'support.okr_consulting.link.text',
    color: '--grade-medium-color-next',
    link: CONSULTATION_CALENDLY_LINK,
    person: 'onboarding-okr-consulting',
    tracking: 'consulting'
  }
].map(box => {
  const { color, title, linkText, ...rest } = box
  const hex = memoizeGetCssVariableValue(color)
  const rgb = memoizeHexToRgb(hex.trim())

  return {
    ...rest,
    hex,
    color,
    rgb,
    title: t(title),
    linkText: t(linkText)
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/marketing-boxes';

.bd-BookingDemo {
  display: grid;
  gap: inherit;
}

.bd-BookingDemo_Item {
  text-decoration: none;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
}

.bd-BookingDemo_BoxContent {
  --box-content-gap: 8px;
  @extend %box-content-style;
}

.bd-BookingDemo_BoxTitle {
  @extend %box-title-style;
}

.bd-BookingDemo_BoxSubtitle {
  @extend %box-subtitle-style;
}

.bd-BookingDemo_BoxButton {
  margin-top: calc(20px - var(--box-content-gap, 0));
  @extend %box-link-style;
  min-width: unset;
  --padding: 4px 6px 4px 12px;
}
</style>
